<template>
  <div>
        <div class="relateOccupation header" :class="{'relateOccupationPC':$store.state.innerWidth>768}">
        <div class="searchOccupations">
            <Breadcrumbs style="position: relative; z-index: 9"></Breadcrumbs>
            <!-- <img v-bind:src="backgroundImg" /> -->
            <div style="top: 0" class="warp-mask"></div>
            <div class="occupation-contain">
                <div class="searchContent occupation-opportunityPC col-sm-10 col-md-12">
                    <h2 class="Bold">{{ $t("message.Careers Exploration") }}</h2>
                    <div class="row">
                        <div class="col-md-4 col-lg-5 pad-10 pad-r-35">
                            <div class="input-group">
                                <b class="i-left">
                                    <i class="icon-search gray" aria-hidden="true"></i>
                                </b>
                                <input 
                                    type="text"  
                                    @keydown.enter="searchFn" 
                                    v-on:click="clickKeyword()" 
                                    v-model="keyword" 
                                    v-bind:placeholder="$t('message.OccupationTitleSkillOrIndustry')" 
                                    class="input-one" 
                                    autocomplete="off" 
                                    :aria-label="$t('message.OccupationTitleSkillOrIndustry')"
                                />
                                <b class="i-right" v-if="keyword" @click="clearEvent">
                                    <i class="icon-close-1 gray" aria-hidden="true"></i>
                                </b>
                            </div>
                        </div>
                        <div class="col-md-4 col-lg-5 pad-10 pad-r-35" :class="{'show':showEducationLevel}">
                            <div class="input-group" @click="openEducationLevel" role="combobox" :aria-label="$t('message.All Education Level')">
                                <b class="i-left">
                                    <i class="icon-box gray" aria-hidden="true"></i>
                                </b>
                                <div class="input-two allInput " style="text-align:left;">
                                    <a href="javascript:;" style="color: inherit">
                                    <span  class="oneline-box"  v-if="!educationLevelDisplay" >{{$t('message.All Education Level')}}</span>
                                    <span  class="oneline-box" v-else >{{educationLevelDisplay}}</span>
                                    </a>
                                </div>
                                <b class="i-right">
                                    <i class="icon-arrow-down mainColor" aria-hidden="true"></i>
                                </b>
                            </div>
                            <div class="criteria-content can-scroll multi-layer criteria-job-func show-choice margin-r-25" :class="{'show':showEducationLevel}" style="text-align: left;top: 5px;">
                                <ul>
                                    <li class="item-table" v-on:click="selectAllEducationLevelFn()" role="option" :aria-label="$t('message.All Education Level')">
                                        <div class="tdcell">
                                            <a href="javascript:;" style="color: inherit">{{$t('message.All Education Level')}}</a>
                                        </div>
                                        <div class="tdcell width-25 text-right">
                                            <span class="check-box " :class="selectedAllEducationLevel?'checked':''"></span>
                                        </div>
                                    </li>
                                    <li class="item-table" v-for="(education,index) in educationList" v-on:click="selectEducationLevelFn(education)" role="option" :aria-label="$store.getters.getContent(education.name)">
                                        <div class="tdcell">
                                            <a href="javascript:;" style="color: inherit">{{$store.getters.getContent(education.name)}}</a>
                                        </div>
                                        <div class="tdcell width-25 text-right">
                                            <span class="check-box " :class="education.selected?'checked':''"></span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-4 col-lg-2 pad-10 ">
                            <div class="search-btn">
                                <div class="btn btn-primary" v-on:click="searchFn()" role="button" :aria-label="$t('message.Search')">
                                    <a href="javascript:;" style="color: inherit">{{$t('message.Search')}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mask" @click="closePopup" :class="{'show':showEducationLevel,'maskPC':$store.state.innerWidth>768}"></div>
        <div class="occupation-contain">
            <div class="occupation-opportunityPC col-sm-10 col-md-8 padLeft-0 padRight-0">
                <div class="jobFunction active">
                    <Occupations v-bind:childLogGaEvent="childLogGaEvent" :jobId="$store.state.formData.jobId" v-bind:keyword="keywordData"  v-bind:educationLevel="educationIdsData" class="occupations"></Occupations>
                </div>
            </div>
        </div>
        
    </div>
    <div class="occupation breadcrumbs-absolute">
        <div class="occupation-contain">
            <div class="occupation-opportunityPC col-sm-10 col-md-8 occupation-bottom">
                <div class="powered-by powered-by-browseOccupations Bold">
                    {{$t('message.Powered by')}} 
                </div>
                <div class="occupation-bottom-imgPlace">
                    <div class="vtc">
                        <a href="https://occupation-dictionary.vtc.edu.hk" target="_blank"  v-if="$store.state.language == 'en_US'"><img :src="VTC" alt="VTC LOGO"></a>
                        <a href="https://occupation-dictionary.vtc.edu.hk/tc" target="_blank"  v-if="$store.state.language == 'zh_HK'"><img :src="VTC" alt="VTC 標誌"></a>
                        <a href="https://occupation-dictionary.vtc.edu.hk/sc" target="_blank"  v-if="$store.state.language == 'zh_CN'"><img :src="VTC" alt="VTC 标志"></a>
                    </div>
                    <div class="inBlue">    
                        <a href=" https://www.linkedin.com" target="_blank" ><img :src="inBlue" alt="inBlue LOGO"></a>
                    </div>
                
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/Breadcrumbs'
import JobFunctionList from '@/components/JobFunctionList'
import Occupations from '@/components/Occupations'
import VTC from '../images/VTC logomark colour.jpg'
import inBlue from '../images/inBlue.png'

export default {
    name:"browseOccupations",
    components: {
        Breadcrumbs,
        JobFunctionList,
        Occupations
    },
    props:[
        "logGaEvent"
    ],
    data() {
        return {
            keyword: "",
            keywordData:"",
            showEducationLevel: false,
            educationLevelDisplay: '',
            selectedAllEducationLevel: false,
            educationList: [],
            educationIds:"",
            educationIdsData:"",
            // backgroundImg: "",
            VTC:VTC,
			inBlue:inBlue,
			jobDetail: {},
        }
    },   
	created() {},
	computed: {
		_language() {
			return this.$store.state.language;
		}
	},
    methods: {
        childLogGaEvent:function(eventCategory, eventAction, eventLabel, eventValue) {
            this.logGaEvent(eventCategory, eventAction, eventLabel, eventValue)
        },
        openEducationLevel: function() {
            this.logGaEvent('userClick','filterBrowseOccupations','Education Level')
            this.showEducationLevel = !this.showEducationLevel;
            if (this.comment.getType()) {
                this.isMobile = true;
            }
        },
        selectAllEducationLevelFn: function() {
            let that = this
            this.logGaEvent('userSelect','educationLevel','All Education Level')
			that.selectedAllEducationLevel = !that.selectedAllEducationLevel
            that.educationList.map(function(v, i) {
                v.selected = that.selectedAllEducationLevel;
                return v
            });
        },
        searchFn: function() {
            this.logGaEvent('search','filterBrowseOccupations',this.keyword)
            this.keywordData=this.keyword
            this.educationIdsData=this.educationIds
        },
        getEducationListFn: function() {
            var that = this
            that.api.getEducationList({}, function(data) {
                that.educationList = data.result.map(function(v, i) { 
                    var ids = [];
                    if(that.educationIds){
                        ids = that.educationIds.split(',')
                    }
                    v.selected = false; 
                    for(var i=0;i<ids.length;i++){
                        if(v.id==ids[i]){
                            v.selected = true;
                        }
                    }
                    return v 
                });
            })
        },
        selectEducationLevelFn: function(obj) {
            this.logGaEvent('userSelect','educationLevel',this.$store.getters.getContent(obj.name))
            obj.selected = !obj.selected;
            let selectedEducation = this.educationList.filter(education => education.selected)

            this.selectedAllEducationLevel = (selectedEducation.length == this.educationList.length)
        },
        clickKeyword:function(){
            this.logGaEvent('userClick','filterBrowseOccupations','Keyword')
        },
        closePopup:function(){
            this.showEducationLevel = false;
        },
        clearEvent:function(){
            this.keyword = ""
            this.searchFn();
		},
		setBreadcrumbs: function() {
			if (this.$route.path.indexOf("RelatedOccupationsJ") > 0) {
				var breadcrumbs = this.$route.meta.breadcrumbs.find(function(b) {
					return b.to.indexOf("findAnOpportunity") > 0 && b.isData;
				});
				if (breadcrumbs) {
					breadcrumbs.text = this.$store.getters.getContent(
						this.jobDetail.title
					);
					breadcrumbs.to = "/findAnOpportunity";
				}
				
			}
		},
		getJobPostingDetail: function(id) {
			var that = this;
			this.api.getJobPostingDetail({ id: id }, function(data) {
				that.jobDetail = data.result;
				that.setBreadcrumbs();
			});
		},
    },
    beforeRouteEnter(to, from, next){       
        if(from.name=='occupationDetails'){
            to.meta.isUseCache = true;
        }else{
            to.meta.isUseCache = false;
        }
        next()
    },
    activated(){
        this.$store.state.selectMenu = 2;
        this.$store.state.mate.title = this.$i18n.t("message.Careers_title")+" - talent.gov.hk - "+this.$i18n.t("message.Default Page Title");
        this.$store.state.mate.description = this.$i18n.t("message.Careers_desc");
        this.$store.state.mate.keywords = this.$i18n.t("message.Careers_keywords");
    
        if(!this.$route.meta.isUseCache) {            
            var that = this;
            this.keyword = '';
            this.educationLevel = '';
            this.keywordData="";
            this.showEducationLevel = false,
            this.educationLevelDisplay = '';
            this.selectedAllEducationLevel = false;
            this.educationList = [];
            this.educationIds = '';
			this.getEducationListFn();
            this.getJobPostingDetail(this.$store.state.formData.jobId)
            window.scrollTo(0,0);
        }

  },
    mounted() {
        var that = this
        setTimeout(function(){
          that.$store.state.mate.title = that.$i18n.t("message.Careers_title")+" - talent.gov.hk - "+that.$i18n.t("message.Default Page Title");
          that.$store.state.mate.keywords = that.$i18n.t("message.Careers_keywords");
        })
        this.$store.state.selectMenu = 2;
        window.scrollTo(0,0);
    },
    watch: {
        educationList: {
            handler: function(val, oldval) {
                let that=this

                let selectedEducations=that.educationList.filter(education=>education.selected)

                this.selectedAllEducations=(selectedEducations.length==this.educationList.length)
                if(that.selectedAllEducations){
                    this.educationLevelDisplay=this.$i18n.t('message.All Education Level')
                }else{
                    this.educationLevelDisplay=selectedEducations.map(
                        function(v,i){return that.$store.getters.getContent(v.name)}
                    ).join(',')
                }
                this.educationIds=selectedEducations.map(function(v,i){return v.id}).join(',')

                
            },
            deep: true
		},
		_language: {
			handler: function(val, oldVal) {
				this.setBreadcrumbs();
			},
			deep: true
		}
    }



}
</script>